import { jsx as t } from "react/jsx-runtime";
const H = ({ size: o = 24, color: r = "currentColor", ...l }) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: o,
    viewBox: "0 0 24 24",
    fill: "none",
    ...l,
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M14.875 9.875H18.8125V13.8125H14.875V23H10.9375V13.8125H7V9.875H10.9375V8.22781C10.9375 6.66725 11.4284 4.69587 12.4049 3.61831C13.3814 2.53812 14.6007 2 16.0615 2H18.8125V5.9375H16.0562C15.4026 5.9375 14.875 6.46513 14.875 7.11744V9.875Z",
        fill: r
      }
    )
  }
);
export {
  H as FacebookIcon
};
